var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.$store.state.api_loading),expression:"$store.state.api_loading"}],attrs:{"id":"app","body":"","fullscreen":"","element-loading-background":"rgba(0, 0, 0, 0.6)"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }